export default __webpack_public_path__ + "static/media/claim_2x.cc7b0c8f.png";